var _metadata, _defs, _g, _mask, _g2, _g3, _mask2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.385888342444105 82.30489907117914",
    width: 55.385888342444105,
    height: 82.30489907117914,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    className: "style-fonts"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.786743200866795 60.020611303057365) rotate(0 0.1291452416003267 6.142143884060886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.09 4.35, 0.18 8.69, 0.26 12.28 M0 0 C0.09 4.16, 0.17 8.32, 0.26 12.28",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(10 10) rotate(0 17.692944171222052 25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.39 25 C35.39 26.45, 35.29 27.92, 35.12 29.34 C34.94 30.77, 34.67 32.19, 34.32 33.55 C33.97 34.91, 33.53 36.25, 33.02 37.5 C32.5 38.75, 31.9 39.96, 31.25 41.07 C30.59 42.18, 29.85 43.22, 29.07 44.15 C28.28 45.08, 27.43 45.93, 26.54 46.65 C25.65 47.37, 24.71 48, 23.74 48.49 C22.78 48.99, 21.77 49.37, 20.77 49.62 C19.76 49.87, 18.72 50, 17.69 50 C16.67 50, 15.63 49.87, 14.62 49.62 C13.61 49.37, 12.6 48.99, 11.64 48.49 C10.68 48, 9.73 47.37, 8.85 46.65 C7.96 45.93, 7.1 45.08, 6.32 44.15 C5.54 43.22, 4.8 42.18, 4.14 41.07 C3.48 39.96, 2.88 38.75, 2.37 37.5 C1.86 36.25, 1.42 34.91, 1.07 33.55 C0.72 32.19, 0.45 30.77, 0.27 29.34 C0.09 27.92, 0 26.45, 0 25 C0 23.55, 0.09 22.08, 0.27 20.66 C0.45 19.23, 0.72 17.81, 1.07 16.45 C1.42 15.09, 1.86 13.75, 2.37 12.5 C2.88 11.25, 3.48 10.04, 4.14 8.93 C4.8 7.82, 5.54 6.78, 6.32 5.85 C7.1 4.92, 7.96 4.07, 8.85 3.35 C9.73 2.63, 10.68 2, 11.64 1.51 C12.6 1.01, 13.61 0.63, 14.62 0.38 C15.63 0.13, 16.67 0, 17.69 0 C18.72 0, 19.76 0.13, 20.77 0.38 C21.77 0.63, 22.78 1.01, 23.74 1.51 C24.71 2, 25.65 2.63, 26.54 3.35 C27.43 4.07, 28.28 4.92, 29.07 5.85 C29.85 6.78, 30.59 7.82, 31.25 8.93 C31.9 10.04, 32.5 11.25, 33.02 12.5 C33.53 13.75, 33.97 15.09, 34.32 16.45 C34.67 17.81, 34.94 19.23, 35.12 20.66 C35.29 22.08, 35.34 24.28, 35.39 25 C35.43 25.72, 35.43 24.28, 35.39 25",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.1618578772368 23.782339686334637) rotate(0 0.28986623067726214 13.369871413125225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.15 7, 0.3 14, 0.58 26.74 M0 0 C0.13 5.95, 0.26 11.9, 0.58 26.74",
    stroke: "#005e79",
    strokeWidth: 4,
    fill: "none"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFall);
export default __webpack_public_path__ + "static/media/fall.ee90b5d2c18b8d9781cdcb406a1f9451.svg";
export { ForwardRef as ReactComponent };